import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TestStepPicture } from '../dto/test-step-picture';

@Injectable({
  providedIn: 'root'
})
export class TestStepPictureService {

  private apiUrl = environment.apiRoot + '/teststeppicture';
    
  constructor(private http : HttpClient) { }

  getAllPicturesOfTestStep(testStepId: number) : Observable<TestStepPicture[]> {
    return this.http.get<TestStepPicture[]>(this.apiUrl + '/allofteststep?testStepId=' + testStepId); 
  }

  getTestStepPicture(testStepPictureId: number) : Observable<ArrayBuffer> {
    return this.http.get(this.apiUrl + '/picture?testStepPictureId=' + testStepPictureId, {responseType: 'arraybuffer'});
  }

  fileUpload(testStepId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post(this.apiUrl + '/fileupload?testStepId=' + testStepId, formData);
  }

  deleteTestStepPicture(testStepPictureId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?testStepPictureId=' + testStepPictureId);
  }
}
